import {
  BASE_AUTH_TOKEN,
  PERMISSIONS_ENUM,
  ROUTE_DOCS_LANDS,
  ROUTE_DOCS_MONITORING,
  ROUTE_DOCS_PROJECTS,
  ROUTE_LOGIN,
} from '@/common/constants';
import useStore from '@/lib/store';
import { Loader2 } from 'lucide-react';
import { Fragment, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const RouteGuard = ({ children }: { children: React.ReactNode }) => {
  const { pathname } = useLocation();
  const {
    user,
    fetchUser,
    fetchPlants,
    fetchMassive,
    fetchLandStatic,
    fetchLandTypes,
    fetchFondTypes,
    fetchPlantsTypes,
  } = useStore();
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem(BASE_AUTH_TOKEN);
  const initAuth = async () => {
    try {
      if (token && !user) {
        await fetchUser();
      }
      if (token) {
        await fetchPlants();
        await fetchMassive();
        await fetchLandStatic();
        await fetchLandTypes();
        await fetchFondTypes();
        await fetchPlantsTypes();
      }
    } finally {
      await setIsLoading(false);
    }
  };

  useEffect(() => {
    initAuth();
  }, [token]);

  if (!token && pathname !== ROUTE_LOGIN) {
    return <Navigate to={ROUTE_LOGIN} replace />;
  }

  if (token && pathname === ROUTE_LOGIN) {
    if (user?.permissions?.includes(PERMISSIONS_ENUM.VIEW_LANDS)) {
      return <Navigate to={'/uz/' + ROUTE_DOCS_LANDS + '/LAND'} replace />;
    }
    if (user?.permissions?.includes(PERMISSIONS_ENUM.VIEW_PROJECTS)) {
      return <Navigate to={'/uz/' + ROUTE_DOCS_PROJECTS} replace />;
    }
    if (user?.permissions?.includes(PERMISSIONS_ENUM.VIEW_STATISTICS)) {
      return (
        <Navigate
          to={
            '/uz/' +
            ROUTE_DOCS_MONITORING +
            `/COTTON${user?.region_id ? '/' + user?.region_id : ''}`
          }
          replace
        />
      );
    }
    return <Navigate to="/" replace />;
  }

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  return <Fragment>{children}</Fragment>;
};
